module.exports = ".readonly{pointer-events:none}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/selectable-action-table/selectable-action-table.component.scss
// module id = ./src/app/access-management/selectable-action-table/selectable-action-table.component.scss
// module chunks = access-management.module